import { Container, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { API_BASE_URL } from "configs/AppConfig";
import LabelLang from "component/LabelLang/label-lang";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";

export default function CensusesSection({ surveyCensuses }) {
  if (!surveyCensuses?.length) return null;

  return (
    <div>
      <h4 style={{ fontWeight: "bold" }}>
        <FormattedMessage id="censuses" />
      </h4>
      <br />
      <div className="row">
        {Object.keys(surveyCensuses).length > 0 ? (
          surveyCensuses.map((item, index) => (
            <div key={index} className="col-3">
              <Container role="button">
                <a href={item?.link} style={{ color: "black" }}>
                  <Row>
                    <img
                      style={{
                        borderColor: "var(--main-color)",
                        borderWidth: 1.5,
                      }}
                      className="img1"
                      src={
                        item?.imageUrl && item?.imageUrl !== "string"
                          ? `${API_BASE_URL}/${item.imageUrl}`
                          : process.env.PUBLIC_URL + "/image/book.png"
                      }
                      alt="arrow"
                      loading="lazy"
                      height="150px"
                    />
                  </Row>
                  <Row style={{ paddingBottom: "10px" }}>
                    <center className="mt-3">
                      <h6>
                        <LabelLang
                          id="title"
                          defaultValue={item?.title}
                          translations={item?.surveyCensuseTranslations}
                        />
                      </h6>
                      <h6>
                        {item?.startYear}
                        {item?.startYear != null && item?.endYear != null ? (
                          <>-</>
                        ) : null}
                        {item?.endYear}
                      </h6>
                    </center>
                  </Row>
                </a>
              </Container>
            </div>
          ))
        ) : (
          <DataNotFound />
        )}
      </div>
      <br />
    </div>
  );
}
